import script from "./LiveIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveIcon.vue?vue&type=script&setup=true&lang=js"

import "./LiveIcon.vue?vue&type=style&index=0&id=1a139dcd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a139dcd"]])

export default __exports__